import React from "react";
import styled from "styled-components";
import { MediaType } from "../../../schemas/Media";
import { MediaImage } from "./MediaImage";
import { MediaHtml5Video } from "./MediaHtml5Video";
import { MediaYouTubeVideo } from "./MediaYouTubeVideo";
import { MediaAudio } from "./MediaAudio";
import { ArticleFeaturedCard } from "../../../molecules/ArticleFeaturedCard";
import { WebActionType } from "../../../schemas/Actions";
const StylableMedia = React.forwardRef(({ media, youtubeLightbox, ...props }, ref) => {
    switch (media.type) {
        case MediaType.IMAGE:
            return React.createElement(MediaImage, { media: media, ...props });
        case MediaType.VIDEO:
            if (media.provider === "youtube") {
                return youtubeLightbox && media.thumbnail ? (React.createElement(ArticleFeaturedCard, { content: {
                        media: media.thumbnail,
                        action: {
                            type: WebActionType.YoutubeVideo,
                            payload: {
                                url: `https://www.youtube.com/watch?v=${media.youtubeId}`,
                                youtubeId: media.youtubeId,
                            },
                        },
                    }, ...props })) : (React.createElement(MediaYouTubeVideo, { media: media, ...props }));
            }
            return React.createElement(MediaHtml5Video, { media: media, ...props, ref: ref });
        case MediaType.AUDIO:
            return React.createElement(MediaAudio, { media: media, ...props, ref: ref });
        default: {
            const _ = media;
            throw new Error(`Warning: unknown media type: ${_}`);
        }
    }
});
StylableMedia.displayName = "StylableMedia";
export const Media = styled(StylableMedia) `
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
//# sourceMappingURL=Media.js.map